<button [disabled]="loadingModal" (click)="selectFile()" class="btn btn-icon px-lg-5 btn-success">
    <i class="mdi" [ngClass]="{'mdi-image-multiple': !loadingModal, 'mdi-loading mdi-spin': loadingModal}"></i>
    <span>Adicionar imagens</span>
</button>

<ng-template #modalContent let-modal>
    <div class="modal-header">
        <h2>Adicionar imagens</h2>
        <button type="button" class="btn btn-xs btn-icon rounded-circle btn-danger" aria-label="Close"
                (click)="cancelBtn(modal)">
            <i class="mdi mdi-close"></i>
        </button>
    </div>
    <div class="modal-body scroll-auto">
        <div class="row">

            <ng-container *ngFor="let f of fotosSelecionadas.controls; let i = index;">

                <div class="col-lg-3 col-md-4 col-sm-6 col-xl-2 p-1 p-md-2">
                    <div class="card card-img-pendente">
                        <button (click)="removerFoto(i)" class="btn btn-danger btn-icon btn-xs rounded-circle">
                            <i class="mdi mdi-close"></i>
                        </button>
                        <img class="rounded-top" [src]="f.value.image" alt="">
                        <div class="bg-light p-2">

                            <div class="ngbDropdown-scroll" placement="bottom-left" ngbDropdown
                                 (openChange)="openSelect($event, f)">
                                <button [ngClass]="{
                                    'btn-danger': f.controls.from.invalid && f.controls.from.touched,
                                    'btn-primary': f.controls.from.valid && f.controls.from.touched
                                    }" 
                                    class="w-100 btn btn-icon btn-sm" id="'DROPDOWNITEM" ngbDropdownToggle>
                                    <span class="w-100 text-left">{{f?.value?.from!='' ? f?.value?.from?.label : 'Selecione'}}</span>
                                    <i class="mdi mdi-chevron-down"></i>
                                </button>
                                <div ngbDropdownMenu aria-labelledby="DROPDOWNITEM">
                                    <div class="px-1 position-relative d-flex align-items-center justify-content-end">
                                        <div class="position-absolute pr-2 f-22 text-muted"><i class="mdi mdi-magnify"></i></div>
                                        <input [(ngModel)]="optionFilter" (ngModelChange)="filter($event)" type="text" class="position-relative bg-transparent form-control form-control-sm">
                                    </div>

                                    <div class="dropdown-divider"></div>

                                    <ng-container *ngFor="let o of options">
                                        <button (click)="setFotoOption(f.controls.from, o)" ngbDropdownItem>
                                            <span>{{o.label}}</span><span class="f-12 text-danger">{{o.required ? '*' : ''}}</span>
                                        </button>
                                    </ng-container>

                                </div>
                                <div class="field" *ngIf="f?.value?.from?.label == 'Foto Adicional'">
                                    <label for="titulo" class="block">Título</label>
                                    <input [(ngModel)]="labelAd[i]" pInputText />
                                </div>
                            </div>
                            <app-msg-erro [control]="f.controls.from"></app-msg-erro>
                        </div>
                    </div>
                </div>

            </ng-container>

        </div>
    </div>
    <div class="modal-footer">
        <button class="px-5 btn btn-info mr-auto" (click)="preencherComoAdicional()">Marcar não preenchidas como
            adicional</button>
        <button class="px-5 btn btn-danger" (click)="cancelBtn(modal)">Cancelar</button>
        <button type="button" class="btn btn-success px-5" (click)="saveBtn(modal)">Confirmar</button>
    </div>
</ng-template>